import React, { type FC } from "react";

import { Icon, type IconProps } from "../../../../Icon";

const CHIP_USER_ICON_TEST_ID = "chip-user-icon-test-id";

interface IChipIcon {
    size?: IconProps["size"];
    icon?: IconProps["icon"];
}

const ChipUserIcon: FC<IChipIcon> = (props) => {
    return (
        <Icon {...(props as IconProps)} data-tsid={CHIP_USER_ICON_TEST_ID} />
    );
};

ChipUserIcon.displayName = "ChipUser.Icon";

export default ChipUserIcon;
